document.addEventListener("DOMContentLoaded", function() {

    // Make sure we're on the correct page
    const form = document.getElementById("cz-authorisation");
    if (!form) return;

    // Signature pad setup
    const canvas = document.getElementById("signature-pad");
    const ctx = canvas.getContext("2d");
    let drawing = false;

    canvas.addEventListener("mousedown", () => drawing = true);
    canvas.addEventListener("mouseup", () => drawing = false);
    canvas.addEventListener("mousemove", draw);

    canvas.addEventListener("touchstart", () => drawing = true);
    canvas.addEventListener("touchend", () => drawing = false);
    canvas.addEventListener("touchmove", drawTouch);

    function draw(e) {
        if (!drawing) return;
        ctx.lineWidth = 2;
        ctx.lineCap = "round";
        ctx.strokeStyle = "#333";
        ctx.lineTo(e.offsetX, e.offsetY);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(e.offsetX, e.offsetY);
    }

    function drawTouch(e) {
        e.preventDefault();
        const rect = canvas.getBoundingClientRect();
        const x = e.touches[0].clientX - rect.left;
        const y = e.touches[0].clientY - rect.top;
        if (!drawing) return;
        ctx.lineWidth = 2;
        ctx.lineCap = "round";
        ctx.strokeStyle = "#333";
        ctx.lineTo(x, y);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(x, y);
    }

    // Clear signature button
    const clearBtn = document.getElementById("clear-signature");
    clearBtn.addEventListener("click", () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    });

    // Capture IP
    fetch("https://api.ipify.org?format=json")
        .then(res => res.json())
        .then(data => {
            const ipField = document.getElementById("ip_address");
            ipField.value = data.ip;
        });

    // Submit handler
    const submitBtn = document.getElementById("cz-submit");
    submitBtn.addEventListener("click", function() {

        const confirmBox = document.getElementById("signature_confirm");
        if (!confirmBox.checked) {
            document.getElementById("cz-response").innerText =
                "Please tick the legal confirmation box before submitting.";
            return;
        }

        const signatureImage = canvas.toDataURL();

        const payload = {
            full_name: document.getElementById("full_name").value,
            customer_email: document.getElementById("cust_email").value,
            authorised_person: document.getElementById("authorised_person").value,
            authority_level: document.getElementById("authority_level").value,
            loan_number: document.getElementById("loan_number").value,
            other_details: document.getElementById("other_details").value,
            signature_typed: document.getElementById("signature_typed").value,
            signature_drawn: signatureImage,
            date_signed: document.getElementById("date_signed").value,
            signature_confirm: confirmBox.checked,
            ip_address: document.getElementById("ip_address").value,
            timestamp: new Date().toISOString(),
            form_type: document.getElementById("form_type").value,
            brand: document.getElementById("brand").value,
            state_compliance: document.getElementById("state_compliance").value,
            version: document.getElementById("version").value
        };

        fetch("https://api.cashzone.com.au/authorisation-handler.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload)
        })
        .then(res => res.text())
        .then(msg => {
            document.getElementById("cz-response").innerText = msg;
            window.location.href =
                "https://cashzone.com.au/pages/authorisation-form-success";
        })
        .catch(err => {
            document.getElementById("cz-response").innerText =
                "There was an error submitting your form.";
        });
    });

});
